import WebApp from '@twa-dev/sdk';

// PARA-135 (A-1, AC-9, AC-E4) — ЕДИНСТВЕННАЯ точка обращения к
// WebApp.HapticFeedback: прямой `import WebApp from '@twa-dev/sdk'` в карточке
// и на экранах запрещён (конвенция features/billing/lib/telegramInvoice.ts).
//
// HapticFeedback появился в Bot API 6.1 — версия проверяется через
// isVersionAtLeast, ручное сравнение строк версии запрещено.

const MIN_HAPTIC_API_VERSION = '6.1';

/** Тактильная отдача доступна: объект есть и клиент не старше 6.1. */
function isHapticsSupported(): boolean {
  return (
    typeof WebApp.HapticFeedback?.impactOccurred === 'function' &&
    typeof WebApp.isVersionAtLeast === 'function' &&
    WebApp.isVersionAtLeast(MIN_HAPTIC_API_VERSION)
  );
}

/** AC-E4: недоступность API и исключение из SDK наружу не всплывают —
 * отдача не является частью основного сценария и не может его сорвать.
 * Логирование намеренно отсутствует: консоль не засоряется на каждом жесте. */
function safely(call: () => void): void {
  if (!isHapticsSupported()) {
    return;
  }
  try {
    call();
  } catch {
    // AC-E4: старый/нестандартный клиент — молча ничего не делаем.
  }
}

/** Импульс в момент срабатывания жеста удержания (AC-6, AC-9). */
export function impact(): void {
  safely(() => WebApp.HapticFeedback.impactOccurred('medium'));
}

/** Отдача успеха после применённого перехода статуса (AC-9). */
export function notifySuccess(): void {
  safely(() => WebApp.HapticFeedback.notificationOccurred('success'));
}

/** Отдача ошибки, когда переход статуса отклонён (AC-9, AC-E1, AC-E2). */
export function notifyError(): void {
  safely(() => WebApp.HapticFeedback.notificationOccurred('error'));
}
